import { render, staticRenderFns } from "./QcTestUpdateFormulationPopUp.vue?vue&type=template&id=015f3a3a&scoped=true&"
import script from "./QcTestUpdateFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./QcTestUpdateFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./QcTestUpdateFormulationPopUp.vue?vue&type=style&index=0&id=015f3a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015f3a3a",
  null
  
)

export default component.exports